import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {FaFilter ,IoSearchSharp ,MdOutlineCancel ,BiReset} from "../../utils/icons"
import { DLabel, DSpinButton, Select } from '../../utils/Form'
function UsersFilter({name,setName,email,setEmail,phoneNumber,setPhoneNumber}) {
    const { t } = useTranslation()
    const [open ,setOpen]=useState(false)
    const [fname,setFname]=useState("")
    const [femail,setFemail]=useState("")
    const [fphoneNumber,setFphoneNumber]=useState("")



    const handeleSearsh =() =>{
if (name !== null) {
    setName(fname)
    }

if (email  !== null) {
    setEmail(femail)
    }
    if (phoneNumber  !== null) {
        setPhoneNumber(fphoneNumber)
        }
    
    

}
 const handelReset =() =>{
    if (name !== null) {
        setName("")
        }
    if (email  !== null) {
        setEmail("")
        }
        if (phoneNumber  !== null) {
            setPhoneNumber()
            }
    
    }
  return (
    <div className='flex  items-center relative flex-col ' >
    <button className=' border bg-n-1 dark:bg-back-darktertiary border-color-1 dark:border-tcolor-2 px-5 py-1 flex flex-row items-center justify-center gap-3 rounded-lg'
    onClick={()=>setOpen(true)}
    >

          <h2 className='h5 dark:text-tcolor-2  text-color-1'>{t("Filter")}</h2>
    <FaFilter size={25} className='text-color-1 dark:text-tcolor-2' /></button>
{
   open &&    
   (<div className="nav-item   absolute border border-gray-200  top-16 bg-white p-8 rounded-lg w-80">
        <button className='p-2 rounded-full text-color-1 my-4 bg-n-1 hover:bg-n-2'
        onClick={()=>setOpen(false)}
        >
<MdOutlineCancel  size={25}/>
        </button>
  { name  !== null  &&
   <DLabel
   labelText="Name"
   value={fname}
   onChange={(e)=> {setFname(e.target.value)}}
   required={true}
   type="text"
   name="name"
 />
  }
         
            { email !== null  &&
                 <DLabel
                 labelText="Email"
                 value={femail}
                 onChange={(e)=> {setFemail(e.target.value)}}
                 required={true}
                 type="text"
                 name="email"
               />
            }
            
            { phoneNumber !== null  &&
                 <DLabel
                 labelText="Phone Number"
                 value={fphoneNumber}
                 onChange={(e)=> {setFphoneNumber(e.target.value)}}
                 required={true}
                 type="number"
                 name="phoneNumber"
               />
            }
            

<div className=" flex flex-row gap-3 py-4 border-t-2 border-gray-200 justify-center items-center">  <DSpinButton 
     onClick={handeleSearsh}
       bgColor={"text-white   bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300  shadow-lg shadow-blue-600/50 "}
       borderColor={"border-none"}
       fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Search")}
     <IoSearchSharp size={22} className='text-white' /></span> 
     </DSpinButton>
      
      <DSpinButton 
     onClick={handelReset}
     bgColor={"text-white  bg-gradient-to-r from-red-600 via-red-700 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300  shadow-lg shadow-red-600/50 "}
     borderColor={"border-none"}
     fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Reset")}
     <BiReset size={22} className='text-white ' /></span> </DSpinButton>
      </div>
   
    </div>)
}

     
      
    </div>
  )
}

export default UsersFilter